import { takeLatest } from 'redux-saga/effects'

import request from 'services/Request'

import * as actionTypes from '../actionTypes'
import * as api from '../api'

function* getGeoWorker() {
  yield request(actionTypes.GEO_REQUESTED, api.getGeo)
}

function* getGeoSaga() {
  yield takeLatest(actionTypes.GEO_REQUESTED, getGeoWorker)
}

export default getGeoSaga
